<label [attr.for]="id" class="v2-mb-2">
  <typography-v2 look="caption-bold">{{ props.label }}</typography-v2>
  <span *ngIf="props.required" class="text-purple v2-ml-1">*</span>
</label>
<ng-template #fieldComponent></ng-template>
